import {action, configure, makeObservable, observable, toJS} from 'mobx';
import canvasService from '../services/canvasServiceOld';
import loadService, {IImage} from '../services/loadService';
import {RouteComponentProps} from 'react-router-dom';
import WebSocketService from '../services/webSocketService';
import React from 'react';
import {storageService} from '../services/storageService';
import {_FILES, _requests, _sia, Tag} from '../configuration/index.config';
import {textInputValidation} from '../services/TextInputValidation.service';
import {has} from 'lodash';
import utilService from '../services/utilService';
import stateMachine from '../services/ClientStateMachine.service';
import {request} from '../services/HttpRequestService';
import logger from '../services/AiLogger';
import {buttonIdsList} from '../Presentational Components/Button/Config/Button.constants';
import fakeUploadClock from '../services/FakeUploadClock.service';

configure({enforceActions: 'never'});
const {MAX_REQUEST_HEIGHT} = _sia.image;
const {WS_RESPONSE_ROUTES, WS_RESPONSE_STATUS} = _requests;
let {DEFAULT_ATTRIBUTES, DEFAULT_LABELS, COLORS} = _sia.json;
const {hitl, gallery} = _sia;

interface IShape {
    id :string,
    label : string,
    attributes : string,
    type : string,
    position : string,
    color : string,
    isInEditMode : boolean,
    coordinates: any
}
export interface ISiaState{
    labelList: string[],
    chosenLabel: string,
    backToStartClassification: () => void,
    isOpenWarningBtn: boolean,
    btnList:any,
    deletedClass:string,
    setDeletedClass: (deletedClass:string) => void,
    setDeletedProject: (deletedProject:string)=> void,
    deletedProject:string,
    setBtnList: (id:string) => void,
    isDeleteWarning:boolean,
    trainLogs:any,
    seIsDeleteWarning: (isDeleteWarning:boolean, backToStart?: () => void) => void,
    totalVideos:number,
    hitlTimeout:any,
    deleteImage: (index: number, isFromVideos?:boolean) => void,
    getImagesFromServer: (d: any) => void,
    deleteImageObj:any,
    editProjectParameters:any,
    totalImages:number,
    videoIndex:number,
    isInCropMode:boolean,
    wsError:boolean | null,
    fileName:string,
    classes:string[],
    classificationSummaryData:any,
    accuracyFinish:boolean,
    className:string,
    attributeList: string[],
    chosenAttribute:string,
    ws:WebSocketService,
    serverWsTaskName:string,
    chosenType:string,
    showPointsList:boolean,
    cursor:string,
    isFinishedHitl: boolean,
    chosenColor:string,
    allShapes:IShape[],
    projectName:string,
    accuracyValid:any,
    videosClassificationFrames: any[],
    accuracyNotValid:any,
    mode:string,
    syntheticColorEdit:any[],
    indexPointInEditMode:number,
    indexRectInEditMode:number,
    indexSegmentEditMode:number,
    imageIndex:number,
    allImages:IImage[] | null[],
    allProperties:any[],
    isInPanMode:boolean,
    canvasRef: React.RefObject<HTMLCanvasElement> | null,
    containerRef: React.RefObject<HTMLDivElement> | null,
    updateType: (type:string) => void,
    setChosenLabel: (value:string) => void,
    setChosenAttribute: (value:string) => void,
    stopEditShape: () => void,
    handleMouseDown:(e) => void,
    isTrainError:boolean,
    isInSyntheticMode:boolean,
    isAutoSave:boolean,
    progressImageTagging:number,
    setPageAfterUpload:any,
    setProgressBarAfterUpload:any,
    handleMove : (e) => void,
    updateChosenLabel : (value, index) => void,
    updateAttribute: (value, index) => void,
    deleteShape : (index) => void,
    editFromTicket: (index) => void,
    setRatio: (ratio) => void,
    addCanvas: (canvasRef: HTMLCanvasElement | null, width: string, height: string, img: IImage | null, index) => void,
    setImageIndex: (index:number) => void,
    setContainerRef: (ref: React.RefObject<HTMLDivElement> | null, canvasRef: React.RefObject<HTMLCanvasElement> | null) => void,
    sendTask : (taskName: string, featureType?:string, featureName?:string, isAutoSave?:boolean) => void,
    responseFromSocket : (data: any) => void,
    setImageOnCanvas: (index) => void,
    setHistory : (history) => void,
    setProjectName : (projectName) => void,
    addToDefaultAttributes: (addedList) => void,
    addToDefaultLabels: (addedList) => void,
    setMode: (mode) => void,
    cropsImages:any[],
    indexCrop:number,
    setCursor: (value : string) => void,
    chooseCropToEdit: (index: number) => void,
    deleteCropOrColor: () => void,
    colorPicker: IColorPicker[],
    indexColor:number,
    chooseColorToEdit: (index: number) => void,
    changeArsenalMode: (index: number) => void,
    isSyntheticImageSentToServer:boolean,
    syntheticPopUpState:{title:string, isButtons:boolean, src:string},
    cancelSyntheticImage: () => void,
    verifySyntheticImage: () => void,
    addCropPic:number,
    addColorPic:number,
    onZoomChange: (scale: number) => void | undefined,
    onScrollEnd : () => void,
    moveDownOrUp : (dir) => void,
    changeCropColorMode: (isInCropMode: boolean) =>void,
    setScrollRefBottom : (ref) => void,
    setLabelList: () => void,
    setAttributeList: () => void,
    isInArsenalMode:boolean,
    SetPanMode: (isPanMode) => void,
    setClasses: (classes) => void,
    findIfLoadMore: () => boolean,
    setSiaDefault: () => void,
    openTaggingModeOrSegmenthorModeSia: any,
    onPressOnImageGallery: (index) => void,
    setColorDefault: (colors) => void,
    setPageAfterUploadSia: (setPageAfterUpload) => void,
    setProgressBarAfterUploadSia: (setProgressBarAfterUpload) => void,
    logOut:(isFromExpireToken:boolean) => void
}
export interface IColorPicker {
    colors:string,
    name:string,
    isAllow:boolean
}
export class SiaStore implements ISiaState {
    @observable labelList: string[] = observable([]);
    @observable isOpenWarningBtn = true;
    @observable deletedProject = '';
    @observable deletedClass = '';
    @observable openTaggingModeOrSegmenthorModeSia:any = null;
    @observable isTrainError = false;
    @observable classes: string[] = observable([]);
    @observable isDeleteWarning = false;
    @observable isInSyntheticMode = false;
    @observable indexCrop = -1;
    @observable indexColor = -1;
    @observable totalVideos = 0;
    @observable isInCropMode = false;
    @observable classificationSummaryData:any ={};
    @observable btnList:any = JSON.parse(JSON.stringify(buttonIdsList));
    @observable isInArsenalMode = true;
    @observable trainLogs = {
        'msg_idx': 0,
        'msg_tot': 11,
        msg: 'Loading...'
    };
    @observable showPointsList = false;
    @observable videoIndex = 0;
    @observable totalImages= 0;
    @observable editProjectParameters:any = {};
    @observable chosenLabel = '';
    @observable serverWsTaskName = '';
    @observable backToStartClassification = () => {};
    @observable fileName ='';
    @observable progressImageTagging = 0;
    @observable wsError = false;
    @observable deleteImageObj:any= null;
    @observable setPageAfterUpload:any = null;
    @observable setProgressBarAfterUpload:any = null;
    @observable accuracyValid = {};
    @observable accuracyNotValid = {};
    @observable accuracyFinish = false;
    @observable className = '';
    @observable mode = 'taggingMode';
    @observable history:RouteComponentProps|null = null;
    @observable isInPanMode = false;
    @observable attributeList: string[] = observable([]);
    @observable chosenAttribute = '';
    @observable cursor = 'crosshair';
    @observable lastType = '';
    @observable chosenType = 'Point';
    @observable chosenColor = 'rgb(255, 100, 6)';
    @observable isAutoSave = false;
    @observable isFinishedHitl = false;
    @observable hitlTimeout:any = null;
    @observable cropsImages:any[] = observable([]);
    @observable allShapes:IShape[] = observable([]);
    @observable indexPointInEditMode = -1;
    @observable indexRectInEditMode = -1;
    @observable indexSegmentEditMode = -1;
    @observable imageIndexInUpdate =-1;
    @observable allImages:IImage[] = observable([]);
    @observable allProperties:any[] = observable([]);
    @observable projectName = '';
    @observable lastDateTime = 0;
    @observable ratio = 0;
    @observable imageIndex = -1;
    @observable containerRef:React.RefObject<HTMLDivElement> | null = null;
    @observable canvasRef: React.RefObject<HTMLCanvasElement> | null = null;
    @observable scrollRefBottom: React.RefObject<HTMLDivElement> | null = null;
    @observable ws:WebSocketService = new WebSocketService();
    @observable colorPicker:IColorPicker[] = observable([]);
    @observable rectColorCopy:any[] = observable([]);
    @observable syntheticColorEdit:any[] = observable([]);
    @observable isSyntheticImageSentToServer = false;
    @observable syntheticPopUpState:{title:string, isButtons:boolean, src:string} = {title: 'Waiting For Synthetic Image', isButtons: false, src: ''}
    @observable addCropPic = -1;
    @observable addColorPic = -1;
    @observable allPatches:any[] = observable([]);
    @observable videosClassificationFrames:any[] = observable([]);
    @observable pathAddServer:any = {}

    constructor() {
        makeObservable(this, {
            indexPointInEditMode: observable,
            allShapes: observable,
            deletedProject: observable,
            allPatches: observable,
            classificationSummaryData: observable,
            pathAddServer: observable,
            deletedClass: observable,
            isSyntheticImageSentToServer: observable,
            syntheticColorEdit: observable,
            isTrainError: observable,
            isDeleteWarning: observable,
            addCropPic: observable,
            syntheticPopUpState: observable,
            colorPicker: observable,
            rectColorCopy: observable,
            indexRectInEditMode: observable,
            indexSegmentEditMode: observable,
            indexColor: observable,
            cropsImages: observable,
            isOpenWarningBtn: observable,
            showPointsList: observable,
            isInArsenalMode: observable,
            allImages: observable,
            isInCropMode: observable,
            indexCrop: observable,
            btnList: observable,
            imageIndex: observable,
            isInSyntheticMode: observable,
            wsError: observable,
            trainLogs: observable,
            accuracyValid: observable,
            accuracyNotValid: observable,
            className: observable,
            ws: observable,
            isInPanMode: observable,
            accuracyFinish: observable,
            cursor: observable,
            totalImages: observable,
            progressImageTagging: observable,
            projectName: observable,
            videosClassificationFrames: observable,
            addColorPic: observable,
        });
        this.indexPointInEditMode = -1;
        this.indexRectInEditMode = -1;
        this.indexSegmentEditMode = -1;
        this.imageIndex = -1;
        this.ws.setWebSocket(this);
    }

    /**
     * setSmallImageLoader - when user delete image and loader need to appear
     * @param isLoad - if loaded animation or not
     * @param index - image index
     * @param isFromCancel - is it from cancel button
     */
    setSmallImageLoader = (isLoad, index, isFromCancel = false) => {
        const copyAllImages = [...this.allImages];

        this.deleteImageObj.index = index;
        this.allImages.splice(0, this.allImages.length);
        copyAllImages[index].isLoadDelete = isLoad;
        this.allImages = copyAllImages;
        ((!isLoad && loadService.allDataFromLocal.length > _FILES.VIDEO.BLACK_LINE) || isFromCancel) && (this.deleteImageObj = null);
    }

    /**
     * setBackToStartClassification - set backToStartClassification ref (function for get back to first page in classification)
     * @param backToStart - ref
     */
    @action setBackToStartClassification = (backToStart) => this.backToStartClassification = backToStart

    /**
     * setDeletedProject - when user delete last image with one class / press on close deleted toggle warning box
     * @param deletedProject - string value
     */
    @action setDeletedProject = (deletedProject) => this.deletedProject = deletedProject;

    /**
     * setDeletedClass - when user delete last image with more then one class / press on close deleted toggle warning box
     * @param deletedClass - string value
     */
    @action setDeletedClass = (deletedClass) => this.deletedClass = deletedClass;

    /**
     * deleteClassFromUI - delete class from ui
     */
    deleteClassFromUI = async () => {
        const index = this.classes.findIndex((c) => c === this.className);

        if (this.classes.length > 1) {
            this.setDeletedClass(this.classes[index]);
            index === this.classes.length - 1 ? this.setClassName(this.classes[index - 1]) : this.setClassName(this.classes[index + 1]);
            await this.moveInClasses();
            this.classes = this.classes.filter((c) => c !== this.deletedClass);
        } else {
            this.setDeletedProject(this.projectName);
            this.backToStartClassification && this.backToStartClassification();
        }
        this.isDeleteWarning = false;
        this.isOpenWarningBtn = true;
    }

    /**
     * seIsDeleteWarning - when user press on delte / back in the warning delte class popup
     * @param isDeleteImage - boolean
     */
    @action seIsDeleteWarning = async (isDeleteImage) => {
        const index = this.deleteImageObj ? this.deleteImageObj.index : 0;

        if (loadService.allDataFromLocal.length <= _FILES.VIDEO.BLACK_LINE && isDeleteImage) {
            const imageDetails = JSON.parse(JSON.stringify(loadService.allDataFromLocal[index]));
            const filename = `${imageDetails.filename}.${imageDetails.fileType}`;

            this.deleteImageObj = {index, filename};
            this.setDeletedClass('');
            this.isOpenWarningBtn = false;
            await this.sendTask('delete_class_s3');
        } else {
            isDeleteImage && (this.deleteImageObj = null);
            isDeleteImage ? this.deleteImage(index, false, true) : this.setSmallImageLoader(false, index, true);
            this.isDeleteWarning = false;
            this.isOpenWarningBtn = true;
        }


    }

    /**
     * setBtnList - when btn need to be enable
     * @param id - the btn id
     */
    @action setBtnList = (id) => this.btnList[id]++;

    /**
     * findIfNeedToDeleteVideosClassification - upload classification process checks if the process is finished (all videos are broke to frames)
     * @param videoAmounts - how many videos
     */
    @action findIfNeedToDeleteVideosClassification = (videoAmounts) => {
        const isSetToDefault = videoAmounts === this.videosClassificationFrames.length && this.videosClassificationFrames.every((video) => video.uploadProgress === 100);

        if (isSetToDefault) {
            this.videosClassificationFrames.splice(0, this.videosClassificationFrames.length);
            this.setLoadTitle('Download images');
        }

        return this.videosClassificationFrames.length;
    }

    /**
     * setVideosClassificationFrames - upload classification process setting the frame process
     * @param data - data from server
     */
    setVideosClassificationFrames = (data) => {
        const name = 'file_basename';
        const i = 'frame_index';
        const total = 'total_frames';
        const index = this.videosClassificationFrames.findIndex((video) => video.name === data[name]);

        if (index > -1) {
            this.videosClassificationFrames[index].uploadProgress = parseInt(`${(data[i] / data[total]) * 100}`, 10);
        } else {
            this.videosClassificationFrames.push({
                name: data[name],
                uploadProgress: parseInt(`${(data[i] / data[total]) * 100}`, 10)
            });
        }

    }

    /**
     * addToPatches - send new patch to server
     * @param type - color / copy
     */
    addToPatches = (type) => {
        const index = type === 'copy' ? canvasService.cropsImages.length - 1 : this.colorPicker.length - 1;
        const patchDetails:any = type === 'copy' ? canvasService.cropsImages[index] : this.colorPicker[index];

        this.pathAddServer = {
            'patch_name': patchDetails.name,
            'patch_data': type === 'copy' ? patchDetails?.data.src : `rgb(${patchDetails.colors})`,
            'patch_type': type,
            index
        };

        this.sendTask('add_patch');
    }

    /**
     * setSyntheticMode - find if in Synthetic Mode
     * @param isInSyntheticMode - boolean true/false
     */
    @action setSyntheticMode = (isInSyntheticMode) => this.isInSyntheticMode = isInSyntheticMode;

    /**
     * changeArsenalMode - arsenalMode in Synthetic Mode
     * @param e - click event
     */
    @action changeArsenalMode = (e) => {
        if (e.clientX) {
            this.stopEditShape();
            this.isInArsenalMode = !this.isInArsenalMode;
            canvasService.isInArsenalMode = this.isInArsenalMode;
            if (!this.isInArsenalMode) {
                canvasService.changePic(loadService!.allDataFromLocal[this.imageIndex]!.img!.src);
            }
        }
        this.setBtnList('arsenal');
    }

    /**
     * chooseColorToEdit - color to edit in Synthetic Mode
     * @param index - index of the color
     */
    @action chooseColorToEdit = (index) => {
        this.addColorPic = index;
    }

    /**
     * chooseCropToEdit - crop to edit in Synthetic Mode
     * @param index - index of the crop
     */
    @action chooseCropToEdit = (index) => {
        this.indexCrop = index;
        if (this.isInArsenalMode) {
            canvasService.clickOnCropImage(index, -1000, -1000);
        } else {
            this.addCropPic = index;
        }

    }

    /**
     * deleteCropOrColor - deleteCropOrColor in Synthetic Mode
     */
    @action deleteCropOrColor = () => {
        this.isInCropMode ? this.deleteCropImage() : this.deleteColorImage();
    }

    /**
     * deleteColorImage - delete chosen color in Synthetic Mode
     */
    deleteColorImage = () => {
        if (this.isInArsenalMode) {
            this.sendTask('delete_patch');
        } else {
            canvasService.deleteRect(canvasService.indexRect);
            this.syntheticColorEdit.splice(canvasService.indexRect, 1);
            this.rectColorCopy.splice(canvasService.indexRect, 1);
            this.indexColor = -1;
        }
    }

    /**
     * sendDeletedPatchToServer - when user wants to delete crop image / color
     * @param index - crop image / color index
     * @param type - crop image / color
     */
    sendDeletedPatchToServer = (index, type) => {
        const patch = type === 'copy' ? canvasService.cropsImages[index] : this.colorPicker[index];

        return patch.name;
    }

    /**
     * deleteCropImage - delete chosen crop in Synthetic Mode
     */
    @action deleteCropImage = () => {
        this.isInArsenalMode ? this.sendTask('delete_patch') : canvasService.deleteCropUi();
    }

    /**
     * setPageAfterUploadSia - has the 'setPageAfterUpload' ref from settingsStore
     * @param setPageAfterUpload - reference
     */
    @action setPageAfterUploadSia = (setPageAfterUpload) => this.setPageAfterUpload = setPageAfterUpload;

    /**
     * setEditProjectParametersSia - has the 'editProjectParameters' ref from settingsStore
     * @param editProjectParameters - reference
     */
    @action setEditProjectParametersSia = (editProjectParameters) => this.editProjectParameters = editProjectParameters;

    /**
     * setProgressBarAfterUploadSia - has the 'setProgressBarAfterUpload' ref from settingsStore
     * @param setProgressBarAfterUpload - reference
     */
    @action setProgressBarAfterUploadSia = (setProgressBarAfterUpload) => this.setProgressBarAfterUpload = setProgressBarAfterUpload;

    /**
     * setColorDefault - set color on page load
     * @param colors - colors list
     */
    @action setColorDefault = (colors) => {
        for (const labelKey in colors) {
            if (has(colors, labelKey)) {
                COLORS[labelKey] = colors[labelKey];
            }
        }
    }

    /**
     * setAttributeList - check attribute list before open main page
     */
    @action setAttributeList = () => {
        this.attributeList.splice(0, this.attributeList.length);
        Object.keys(DEFAULT_ATTRIBUTES).forEach((key) => {
            key.length > 0 && this.attributeList.push(key);
        });
        this.setBtnList('addNewInput');
    }

    /**
     * deleteImageFromUi - when image can be delete remove it from the UI
     */
    deleteImageFromUi =async () => {
        if (this.mode === Tag.CLASSIFICATION && loadService.allDataFromLocal.length <= _FILES.VIDEO.BLACK_LINE) {
            this.deleteImageObj = null;

            return;
        }

        if (this.deleteImageObj) {
            await logger.sendLog(`user ${storageService.loadFromStorage('username')} deleted image ${this.deleteImageObj.filename}`);
            const copyAllImages = this.allImages.filter((image) => image.filename !== this.deleteImageObj.filename);
            const projectKey = 'project_data';
            const fileKey = 'img_name';

            this.allImages.splice(0, this.allImages.length);
            this.allImages = copyAllImages;
            this.allProperties.splice(this.deleteImageObj.index, 1);
            loadService.allDataFromLocal.splice(this.deleteImageObj.index, 1);

            if (loadService.classificationObj[projectKey] && loadService.classificationObj[projectKey][this.className]) {
                const copy = loadService.classificationObj[projectKey][this.className].filter((image) => image[fileKey] !== this.deleteImageObj.filename);

                loadService.classificationObj[projectKey][this.className] = copy;
            }

            if (this.allImages.length === 0) {
                this.history && this.history.push('/old_factory');
            } else {
                this.totalImages--;
                this.allImages.length < gallery.MAX_IMAGE_SIZE && this.onScrollEnd();
                this.imageIndex = this.deleteImageObj.index <= this.allImages.length - 1 ? this.deleteImageObj.index : this.allImages.length - 1;
                this.setImageOnCanvas(this.imageIndex);
            }
            this.deleteImageObj = null;
        }
    }

    /**
     * deleteImage - when user wants to delete image
     * @param index - image index
     * @param isFromVideos - is from video mode
     * @param isDeleteOverRedLine - if user want to delete image over the red line (in classification)
     */
    @action deleteImage = (index, isFromVideos = false, isDeleteOverRedLine = false) => {
        const isActivateDelete = this.mode === Tag.CLASSIFICATION ? loadService.allDataFromLocal.length > _FILES.VIDEO.RED_LINE : true;

        const imageDetails = JSON.parse(JSON.stringify(loadService.allDataFromLocal[index]));
        const filename = `${imageDetails.filename}.${imageDetails.fileType}`;

        if (textInputValidation.checkValidValueRegex(filename, 'FILE_NAME_REGEX') && !this.deleteImageObj) {
            this.deleteImageObj = JSON.parse(JSON.stringify({
                filename,
                index
            }));
            this.setSmallImageLoader(true, index);
            const deleteName = (this.mode === Tag.DEFAULT || this.mode === Tag.CLASSIFICATION) ? 'delete_image_s3' : 'delete_video_s3';

            if (isActivateDelete || isDeleteOverRedLine) {
                !isFromVideos && this.sendTask(deleteName);
                isFromVideos && this.deleteImageFromUi();
            } else {
                this.isDeleteWarning = true;
            }
        }


    }

    /**
     * setLabelList -  check label list before open main page
     */
     @action setLabelList = () => {
         this.labelList.splice(0, this.labelList.length);
         Object.keys(DEFAULT_LABELS).forEach((key) => {
             key.length > 0 && this.labelList.push(key);
         });
         this.setBtnList('addNewInput');
     }

    /**
     * setClasses - set classes (classifications parameters)
     * @param classes - classifications parameters
     */
    @action setClasses = (classes) => this.classes = classes;

    /**
     * setClassName - set the class name that active on Ui
     * @param className - the class name that active on Ui
     */
    @action setClassName = (className) => this.className = className;

    /**
     * setScrollRefBottom - set scroll ref bottom
     * @param ref - html element (the scroll div)
     */
    setScrollRefBottom = (ref) => this.scrollRefBottom = ref;

    /**
     * setMode - is the user in tagging mode or listener
     */
    @action setMode=(mode) => {
        this.mode = mode;
        this.mode === Tag.SEGMENTHOR && (canvasService.setCropsImages(this.cropsImages, (type) => this.addToPatches(type), this.projectName));
    }

    /**
     * addToList - add new shape to list
     */
    @action addToList=(coordinates, index) => {
        let position = coordinates;

        if (!position.length) {
            position = Object.values(coordinates);
        } else {
            position = position.map((arr) => Object.values(arr));
        }
        const newShape = {
            id: `${this.chosenType.toLowerCase()}_${index}`,
            label: this.chosenLabel,
            attributes: this.chosenAttribute,
            type: this.chosenType.toLowerCase(),
            position: position.join(','),
            coordinates,
            color: this.chosenColor,
            isInEditMode: true
        };

        this.allShapes.push(newShape);
    }

    /**
     * cleanList - delete all shapes
     */
    @action cleanList = () => {
        this.allShapes.splice(0, this.allShapes.length);
    }

    /**
     * verifySyntheticImage - if user verify Synthetic Image
     */
    @action verifySyntheticImage = () => {
        this.isSyntheticImageSentToServer = false;
        canvasService.changePic(this.syntheticPopUpState.src);
        loadService.changeImageInLoadArray(this.syntheticPopUpState.src, this.imageIndex);
        this.syntheticPopUpState.src = '';
        this.syntheticPopUpState.title = 'Waiting For Synthetic Image';
        this.syntheticPopUpState.isButtons = false;
        this.rectColorCopy.splice(0, this.rectColorCopy.length);
        this.syntheticColorEdit.splice(0, this.syntheticColorEdit.length);
        canvasService.clearCanvas();
        canvasService.cropsPictures.splice(0, canvasService.cropsPictures.length);
        this.isInSyntheticMode = false;
        this.isInArsenalMode = true;
        this.isInCropMode = true;
        this.stopEditShape();
    }

    /**
     * setCursor - set cursor of imagepresnter
     * @param value - cursor value
     */
    @action setCursor = (value) => this.cursor = value;

    /**
     * setCropCopyMode - set canvas service isInCropMode to false
     */
    setCropCopyMode = () => canvasService.isInCropMode = false;

    /**
     * cancelSyntheticImage - if user not verify Synthetic Image
     */
    @action cancelSyntheticImage = () => {
        !this.isInCropMode && this.setCropCopyMode();
        this.isSyntheticImageSentToServer = false;
        this.syntheticPopUpState.src = '';
        this.syntheticPopUpState.title = 'Waiting For Synthetic Image';
        this.syntheticPopUpState.isButtons = false;
        this.stopEditShape();
    }

    /**
     * returnToVideoTag - when user wants to return to tag mode from Synthetic mode
     */
    @action returnToVideoTag = () => {
        // canvasService.cropsPictures.splice(0, canvasService.cropsPictures.length);
        const allShapesObject = toJS(this.allShapes);

        this.isInSyntheticMode = false;
        canvasService.isInSyntheticMode = false;
        this.allProperties[this.imageIndex] = allShapesObject;
        this.setImageOnCanvas(this.imageIndex);
    }

    /**
     * logOut - when user wants to log out / expire token
     * @param isFromExpireToken - boolean, if this function called from ExpireToken
     */
    @action logOut = async (isFromExpireToken = false) => {
        storageService.removeFromStorage('username');
        const token = storageService.loadFromStorage('token');

        token && !isFromExpireToken && await request.get(token, 'DISCONNECT', false, '');
        storageService.removeFromStorage('token');
        window.location.href = '/';
        this.setBtnList('logOut');
    };

    /**
     * setHistory - get history project from 'RouteComponentProps' (will control on page move)
     */
    @action setHistory = (history) => this.history = history;

    /**
     * setProjectName - set project name (from settings page
     */
    @action setProjectName = (projectName) => {
        this.projectName = projectName;
    }

    /**
     * sendTask - send task to websocket (backend)
     */
    // eslint-disable-next-line complexity
    @action sendTask = async (taskName, featureType = 'cascadeAi', featureName = 'quantumBackCombo', isAutoSave = false) => {
        const refreshData = storageService.loadFromStorage('refresh');
        const userKey = 'user_name';
        const fileNameKey = 'file_name';
        const filesNamesKey = 'file_names';
        const patchDict = 'patch_dict';
        const frameRateKey = 'frame_rate';
        const className = 'class_name';
        const taskId = 'task_id';
        const editKey = 'edit_dict';
        const emailsList = 'emails_list';
        const patchName = 'patch_name';
        const patchData = 'patch_data';
        const patchType = 'patch_type';
        const sessionId = 'session_id';
        const deleteName = (this.mode === Tag.DEFAULT || this.mode === Tag.CLASSIFICATION) ? 'delete_image_s3' : 'delete_video_s3';
        const taskIdArray = storageService.loadFromStorage('taskId');
        const base64Data = loadService.base64Data[0];
        let cropArray:any = [];
        const copyAllImages = [...this.allImages];
        let cropsPromises:any = [];
        let projectKey = 'project_list';

        if (refreshData.typeToggle === Tag.DEBUG) {
            projectKey = 'unique_request_id';
        } else if (refreshData.typeToggle !== Tag.LISTEN || !refreshData.typeToggle) {
            projectKey = 'project_name';
        }

        const data:any = {
            task: taskName,
            [sessionId]: stateMachine.getSessionId(),
            [projectKey]: this.projectName,
            token: storageService.loadFromStorage('token')
        };

        const updateData = loadService.allDataFromLocal[this.imageIndex];
        const patch = toJS(this.pathAddServer);
        let accuracyData = {};

        switch (taskName) {
            case 'uploading_file_request':
                if (base64Data) {
                    data[fileNameKey] = base64Data.name;
                    data.num_of_packets = base64Data.fileChunks.length;
                }
                break;
            case 'uploading_file_packet':
                if (base64Data) {
                    data[fileNameKey] = base64Data.name;
                    data.data_packet = base64Data.fileChunks[base64Data.index][0];
                    data.packet_index = base64Data.index;
                }
                break;
            case 'delete_patch':
                data[patchName] = this.isInCropMode ? this.sendDeletedPatchToServer(this.indexCrop, 'copy') : this.sendDeletedPatchToServer(this.addColorPic, 'color');
                break;
            case 'add_patch':
                data.patches = [{[patchName]: patch[patchName], [patchData]: patch[patchData], [patchType]: patch[patchType]}];
                break;
            case 'synthetic_create_image_and_send':
                data[fileNameKey] = `${updateData!.filename}.${updateData!.fileType}`;

                cropsPromises = canvasService.cropsPictures.map(async (crop) => {
                    const cord = {coordinates: [{x: crop.positionX, y: crop.positionY, z: 0}, {x: crop.positionX + crop.width, y: crop.positionY + crop.height, z: 0}]};
                    const {src} = canvasService.cropsImages[crop.indexImage]!.data;
                    const image = Buffer.from(src, 'base64').toString('base64') === src ? src : await utilService.getBase64FromUrl(src);

                    this.isSyntheticImageSentToServer = true;

                    return {
                        'patch_name': `crop_${crop.indexImage}`,
                        image,
                        'patch_type': 'copy',
                        color: [],
                        'is_inverted': true,
                        'is_manual_threshold': false,
                        'dilate_scroll': 1,
                        'threshold_scroll': 0,
                        'blur_scroll': 1,
                        coordinates: loadService.setCoordinatesToCorrectSize(cord, this.ratio, true).coordinates
                    };
                });

                cropArray = await Promise.all(cropsPromises);
                canvasService.rectList.length > 0 && this.setRectsColorCopy();
                this.rectColorCopy.forEach((rectColor, index) => {
                    const colorObj = {
                        'patch_name': `color_${index}`,
                        image: '',
                        'patch_type': 'color',
                        color: rectColor.color,
                        coordinates: loadService.setCoordinatesToCorrectSize(rectColor, this.ratio, true).coordinates
                    };

                    cropArray.push({
                        ...colorObj,
                        ...this.syntheticColorEdit[index]
                    });
                });

                data[patchDict] = cropArray;
                if (cropArray.length > 0) {
                    this.stopEditShape();
                    this.isSyntheticImageSentToServer = true;
                    loadService.allDataFromLocal[this.imageIndex]!.imageObject.synthetic = JSON.parse(JSON.stringify(cropArray));
                } else {
                    Object.assign(data, {});
                }

                break;
            case 'train_deploy_model':
                data[emailsList] = [];
                this.trainLogs.msg_idx = 1;
                data.classes = this.classes;
                break;
            case 'cancel_task':
                data[taskId] = taskIdArray.length === 1 ? taskIdArray[0] : taskIdArray[this.imageIndex];
                break;
            case 'add_accuracy_user':
                this.accuracyFinish = false;
                Object.assign(data, refreshData.accuracyObj);
                break;
            case 'delete_multiple_images_s3':
                data[filesNamesKey] = loadService.imagesNames;
                break;
            case 'edit_project_params':
                data[editKey] = this.editProjectParameters;
                break;
            case 'update_annotation_data':
                if (refreshData.typeToggle === Tag.DEFAULT) {
                    this.setImageIndex(this.imageIndex, true);
                    this.isAutoSave = isAutoSave;
                    updateData!.imageObject.annotations.forEach((annotate) => {
                        annotate.type === 'segment' && !annotate.coordinates[0].length && (annotate.coordinates = [annotate.coordinates]);
                    });
                    if (!isAutoSave) {
                        this.imageIndexInUpdate = this.imageIndex;
                        if (updateData!.imageObject.annotations) {
                            loadService.allDataFromLocal.length > this.progressImageTagging && !updateData!.imageObject.finished && this.progressImageTagging++;
                            updateData!.imageObject.finished = true;
                        }
                    }
                    const tagger = {
                        userName: storageService.loadFromStorage('username'),
                        lastModify: `${new Date().toLocaleString()} ${Intl.DateTimeFormat().resolvedOptions().timeZone}`
                    };

                    data.params = {json: {annotations: updateData!.imageObject.annotations, finished: updateData!.imageObject.finished, className: this.className, tagger}, [fileNameKey]: `${updateData!.filename}.json`};
                }
                break;
            case 'annotate_video':
                this.allImages.splice(0, this.allImages.length);
                copyAllImages[this.imageIndex]!.buttonMode = 'cancel';
                loadService.setAllDataFromLocalJson(this.imageIndex, toJS(this.allShapes), this.ratio);
                data[fileNameKey] = `${updateData!.filename}.${updateData!.fileType}`;
                data.json = updateData!.imageObject;
                data[frameRateKey] = +refreshData.frameSampling;
                this.allImages = copyAllImages;
                break;
            case 'open_train_project':
                data.classes = this.classes;
                break;
            case 'annotate_project':
                data.params = {'desired_height': MAX_REQUEST_HEIGHT, 'feature_type': featureType, 'feature_name': featureName};
                break;
            case 'add_listener_channel':
                data[userKey] = storageService.loadFromStorage('username');
                window.location.pathname !== '/main' && this.history.push('/main');
                this.setAttributeList();
                this.setLabelList();
                break;
            case 'mark_hitl_verified_image':
                data[userKey] = storageService.loadFromStorage('username');
                data.params = {'unique_request_id': updateData!.unique_request_id, json: updateData!.imageObject, isFinished: this.isFinishedHitl};
                break;
            case 'delete_class_s3':
                data[className] = this.className;
                break;
            case deleteName:
                data[fileNameKey] = this.deleteImageObj.filename;
                data[className] = this.className;
                break;
            case 'finish_request':
                loadService.setAllDataFromLocalJson(this.imageIndex, toJS(this.allShapes), this.ratio, this.className);
                accuracyData = updateData ? {'unique_request_id_dict': {id: updateData.unique_request_id, 'new_result': updateData.imageObject}} : {};
                data[userKey] = storageService.loadFromStorage('username');
                Object.assign(data, accuracyData);
                this.allImages.splice(this.imageIndex, this.imageIndex + 1);
                this.allProperties.splice(this.imageIndex, this.imageIndex + 1);
                loadService.deleteDataFromAllDataFromLocal(this.imageIndex);
                this.className = '';
                this.setImageOnCanvas(this.imageIndex);
                this.imageIndex = -1;
                break;
            default:
                break;
        }
        data && this.ws.sendMessage(data);
    };

    /**
     * setHitlTimeOut - hitl (human in the loop) time out clock
     * @param time - the time for user that can edit
     * @param isClear - if need to clear clock
     */
    setHitlTimeOut = (time, isClear) => {
        const refreshData = storageService.loadFromStorage('refresh');

        if (refreshData.typeToggle === Tag.LISTEN) {
            if (isClear) {
                clearTimeout(this.hitlTimeout);
                this.hitlTimeout = null;

                return;
            }

            clearTimeout(this.hitlTimeout);
            this.hitlTimeout = setTimeout(() => {
                if (this.imageIndex > -1 && this.ws.isActive) {
                    this.hitlTimeout = null;
                    this.isFinishedHitl = false;
                    this.sendTask('mark_hitl_verified_image');
                }

            }, time);
        }
    }

    /**
     * moveInClasses - when change class (in classification mode)
     */
    @action moveInClasses = async () => {
        this.allImages.splice(0, this.allImages.length);
        this.allProperties.splice(0, this.allProperties.length);
        loadService.allDataFromLocal.splice(0, loadService.allDataFromLocal.length);
        this.imageIndex = -1;
        await this.getImagesFromServer(loadService.classificationObj);
        this.setBtnList('move');
    }

    /**
     * getImagesFromServer - general function of image from server
     * @param d -data
     */
    @action getImagesFromServer = async (d) => {
        let index = 0;
        let dataArray = JSON.parse(JSON.stringify([d]));
        const wsRes = WS_RESPONSE_ROUTES;

        if (d.project_data) {
            dataArray = d.project_data.length > 0 ? JSON.parse(JSON.stringify(d.project_data)) : JSON.parse(JSON.stringify(d.project_data[this.className]));
        }

        this.totalImages = dataArray.length;
        for (const dataImages of dataArray) {
            if (d.type === wsRes.VIDEO_FIRST_FRAME) {
                this.totalVideos === 0 && this.sendTask('get_project_patches');
                this.totalVideos = dataImages.total_videos;

            }
            if (this.ws.isActive && dataImages.img) {
                // eslint-disable-next-line no-loop-func
                await loadService.addDataToArray(dataImages).then((data) => {
                    if (this.ws.isActive) {
                        if (this.mode === Tag.DEFAULT) {
                            data.img.finished = !!data.imageObject.finished;
                            data.img.finished && this.progressImageTagging++;
                        }
                        index++;
                        if (dataArray.length === index) {
                            this.onScrollEnd();
                            (window.location.pathname === '/settings' || window.location.pathname === '/analyze_debug') && this.history.push('/main');
                            if (this.imageIndex === -1) {
                                this.mode === Tag.DEBUG && canvasService.changeShowLabels(true);
                                this.imageIndex = 0;
                                this.setImageOnCanvas(0);
                            }
                            this.mode === Tag.LISTEN && clearTimeout(this.hitlTimeout);
                            this.mode === Tag.LISTEN && this.setHitlTimeOut(hitl.IME_DELAY_BASIC, false);
                        }
                    }
                });
            }
        }
    }

    /**
     * saveTagChanges - autosave changes when user tag new annotation
     */
    saveTagChanges = () => {
        if (!this.isAutoSave) {
            this.isAutoSave = true;
            this.moveDownOrUp(1);
            this.imageIndexInUpdate >= 0 && this.imageIndexInUpdate < this.allImages.length && (this.allImages![this.imageIndexInUpdate]!.finished = true);
        }
    }

    /**
     * createSyntheticImage - when user wants to create Synthetic Image
     * @param data - the data of the popup
     */
    createSyntheticImage = (data) => {
        this.syntheticPopUpState.isButtons = true;
        this.syntheticPopUpState.src = data.img;
        this.syntheticPopUpState.title = 'Verify Synthetic Image';
        this.setBtnList('createSynthetic');
    }

    /**
     * hitlSaveTagChanges - save changes in HITL (human in the loop)
     */
    hitlSaveTagChanges = () => {
        this.allImages.splice(this.imageIndex, this.imageIndex + 1);
        this.allProperties.splice(this.imageIndex, this.imageIndex + 1);
        loadService.deleteDataFromAllDataFromLocal(this.imageIndex);
        this.setImageOnCanvas(this.imageIndex);
        this.imageIndex = -1;
        this.setHitlTimeOut(hitl.IME_DELAY_BASIC, true);
    }

    /**
     * saveTaskId - save Task Id (websocket task id)
     * @param data - data of the task id
     */
    saveTaskId = (data) => {
        const taskIdArray = storageService.loadFromStorage('taskId');

        taskIdArray ? storageService.saveToStorage('taskId', [...taskIdArray, data.task_id], true) : storageService.saveToStorage('taskId', [data.task_id]);
    }

    /**
     * updateVideoStatus - whan new frame in video comes
     * @param data - the video data
     */
    updateVideoStatus = (data) => {
        const index = loadService.findFromAllDataByName(data);

        if (index > -1) {
            const copyAllImages = [...this.allImages];

            this.allImages.splice(0, this.allImages.length);
            copyAllImages[index]!.isVideoLoad = false;
            copyAllImages[index]!.finished = true;
            this.allImages = copyAllImages;
        }
        this.videoIndex++;
    }

    /**
     * setLoadTitle - !this reference other function!
     */
    setLoadTitle: (loadTitle:string) => void | null = () => {};

    /**
     * setLoadTitleRef - set the 'setLoadTitle' function
     * @param setLoadTitleFunc - the call back function
     */
    setLoadTitleRef = (setLoadTitleFunc) => this.setLoadTitle = setLoadTitleFunc;

    /**
     * setAccuracyStatistics - set the accuracy statistics (popup in the end of accuracy mode)
     * @param data - accuracy data
     */
    setAccuracyStatistics = (data) => {
        this.accuracyValid = data.Valid;
        this.accuracyNotValid = data.Not_Valid;
        this.accuracyFinish = true;
    }

    /**
     * finishDownLodZip - download zip file
     * @param data - zip file data
     */
    finishDownLodZip = (data) => {
        this.setPageAfterUpload(this);
        loadService.handleDownload(data.zip_signed_url, data.zip_file_name);
        this.ws.closeConnection();
    }

    /**
     * setVideoProject - when new frame in video project comes
     * @param data - video data
     */
    setVideoProject = async (data) => {
        const index = loadService.findFromAllDataByName(data);

        index > -1 && (this.allImages![index]!.isVideoLoad = true);
        if (index > -1 && (index === this.imageIndex || +data.vid_index === 241)) {
            await loadService.addDataToArray(data, index).then((imageData) => {
                this.allProperties[index] = JSON.parse(JSON.stringify(imageData!.imageObject.annotations));
                index === this.imageIndex && this.setImageOnCanvas(this.imageIndex);
            });
        }
    }

    /**
     * deletePatchFromArsenalUi - when user wants to delete patch from arsenal
     * @param data - the patch data
     */
    deletePatchFromArsenalUi = (data) => {
        if (data.status === WS_RESPONSE_STATUS.SUCCESS) {
            if (this.indexCrop > -1) {
                canvasService.deleteCrop(this.indexCrop);
                this.indexCrop = -1;
            } else {
                this.colorPicker.splice(this.addColorPic, 1);
                this.addColorPic = -1;
            }
        }
    }

    //TODO: create chunks service
    /**
     * sendHdf5ChunkToServer - send chunks of hdf5 file
     * @param data - the chunk data
     */
    sendHdf5ChunkToServer = async (data) => {
        const base64Data = loadService.base64Data[0];

        if (base64Data.index === data.index + 1 || base64Data.index === 0) {
            await this.sendTask('uploading_file_packet');
            base64Data.index += 1;
            fakeUploadClock.receiveProgressFromOutSide(parseInt(`${(base64Data.index / (base64Data.fileChunks.length + 1)) * 80}`, 10));
        }
    }

    /**
     * getProjectPatches - get all patches in the project
     * @param data - patches data
     */
    getProjectPatches = (data) => {
        this.colorPicker = data.patches.map((patch) => {
            if (patch.patch_type === 'copy') {
                canvasService.setCropsImagesFromServer(patch.patch_data, patch.patch_name);

                return null;
            }

            return {
                name: patch.patch_name,
                colors: patch.patch_data ? patch.patch_data.match(/\d+/g).map(String).join() : '',
                isAllow: !!patch.patch_data
            };
        });
        const copyCrops = [...canvasService.cropsImages];

        this.cropsImages.splice(0, this.cropsImages.length);
        this.cropsImages.push(...copyCrops);
        this.colorPicker = this.colorPicker.filter((patch) => patch);
    }
    //TODO: need to change this to each component will receive the data from ws like in Configuration.controller
    /**
     * responseFromSocket - the function that receive the data from websocket (server)
     * @param data - server data
     * uploadStatus - regarding user press on update or change something in tag mode (the answer from serer after it happened)
     * listen_uploadStatus - regarding user press on update or change something in listen mode (the answer from serer after it happened)
     * image_json_uploaded - when server received image (in upload process)
     * get-images - in the two modes
     */
    // eslint-disable-next-line complexity
    @action responseFromSocket = async (data:any) => {
        this.serverWsTaskName = data.type || '';
        const wsRes = WS_RESPONSE_ROUTES;

        switch (data.type) {
            case wsRes.GROUP_UPDATED:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.TRAINING_ERROR:
                this.isTrainError = true;
                break;
            case wsRes.GROUP_ADDED:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.GET_ALL_GROUPS:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.GET_FEATURE_META:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.GET_SEGMENTATION_RATIOS:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.GET_CASCADE_MODES:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.FILE_UPLOADED_SUCCESSFULLY:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.GET_CONFIGURATION_INIT:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.CONFIGURATION_FEATURE_ADDED:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.CONFIGURATION_FEATURE_UPDATED:
                this.ws.getDataFromWS(data);
                break;
            case wsRes.CLASSIFICATION_SUMMARY:
                this.classificationSummaryData = data;
                break;
            case wsRes.OPEN_PROJECT_DETAILS:
                if (data.msg) {
                    this.setLoadTitle(data.msg);
                } else {
                    this.setLoadTitle('Break videos to frames');
                    this.setVideosClassificationFrames(data);
                }

                break;
            case wsRes.SAVE_TAG_CHANGES:
                this.saveTagChanges();
                break;
            case wsRes.GET_PROJECT_PATCHES:
                this.getProjectPatches(data);
                break;
            case wsRes.DELETE_PATCH:
                this.deletePatchFromArsenalUi(data);
                break;
            case wsRes.ADD_PATCH:
                if (data.patch_type === 'copy') {
                    canvasService.cropsImages[this.pathAddServer.index].isAllow = true;
                    const copyCrops = [...canvasService.cropsImages];

                    this.cropsImages.splice(0, this.cropsImages.length);
                    this.cropsImages.push(...copyCrops);
                } else {
                    this.colorPicker[this.pathAddServer.index].isAllow = true;
                    const copyColorPicker = [...this.colorPicker];

                    this.colorPicker.splice(0, this.colorPicker.length);
                    this.colorPicker.push(...copyColorPicker);
                }

                break;
            case wsRes.CREATE_SYNTHETIC_IMAGE:
                this.createSyntheticImage(data);
                break;
            case wsRes.HITL_SAVE_TAG_CHANGES:
                this.hitlSaveTagChanges();
                break;
            case wsRes.TRAIN_STATUS:
                if (data.msg_idx !== this.trainLogs.msg_idx) {
                    this.trainLogs = data;
                    await stateMachine.setStoreOrServiceData([{serviceName: 'siaStore', newData: {trainLogs: this.trainLogs}}]);
                }
                break;
            case wsRes.AUTO_TAG_UPLOAD_STATUS:
                this.setPageAfterUpload(this);
                break;
            case wsRes.AUTO_TAG_TASK_ID:
                this.saveTaskId(data);
                break;
            case wsRes.DOWNLOAD_PROJECT_TASK_ID:
                this.saveTaskId(data);
                break;
            case wsRes.SEGMENTHOR_TASK_ID:
                this.saveTaskId(data);
                break;
            case wsRes.EDIT_PROJECT_PARAMS:
                this.ws.closeConnection();
                setTimeout(() => {
                    this.openTaggingModeOrSegmenthorModeSia();
                }, 500);
                break;
            case wsRes.HEART_BEAT:
                setTimeout(() => {
                    this.ws.sendHeartBeat();
                }, 3000);
                break;
            case wsRes.DELETE_CLASS:
                if (data.status.toLocaleLowerCase().includes('success')) {
                    await this.deleteClassFromUI();
                } else {
                    this.setSmallImageLoader(false, this.deleteImageObj.index);
                    this.isDeleteWarning = false;
                    this.isOpenWarningBtn = true;
                }
                break;
            case wsRes.DELETE_IMAGE:
                if (data.Status.toLocaleLowerCase().includes('success')) {
                    await this.deleteImageFromUi();
                } else {
                    this.setSmallImageLoader(false, this.deleteImageObj.index);
                }
                break;
            case wsRes.VIDEO_ANNOTATION_STATUE:
                this.updateVideoStatus(data);
                break;
            case wsRes.IMAGE_ANNOTATION_STATUE:
                this.setProgressBarAfterUpload(1, data.img_index);
                break;
            case wsRes.ACCURACY_STATISTICS:
                this.setAccuracyStatistics(data);
                break;
            case wsRes.MISSING_DATA:
                this.wsError = true;
                break;
            case wsRes.DELETE_PROJECT:
                this.setPageAfterUpload(this);
                break;
            case wsRes.DELETE_MULTI_IMAGES:
                this.setPageAfterUpload(this);
                break;
            case wsRes.ZIP_INFO:
                this.setProgressBarAfterUpload(1, data.img_num, [], null, '', data.total_images);
                break;
            case wsRes.ZIP_FILE_STATUS:
                this.finishDownLodZip(data);
                break;
            case wsRes.START_UPLOAD_HDF5_CHUNKS:
                await this.sendHdf5ChunkToServer(data);
                break;
            case wsRes.UPLOAD_HDF5_CHUNKS:
                loadService.base64Data[0].index === loadService.base64Data[0].fileChunks.length
                    ? await this.ws.getDataFromWS(data) : await this.sendHdf5ChunkToServer(data);
                break;
            case wsRes.HDF5_HAS_UPLOADED:
                loadService.base64Data.push(data);
                fakeUploadClock.receiveProgressFromOutSide(100);
                break;
            case wsRes.VIDEO_FRAME:
                await this.setVideoProject(data);
                break;
            default:
                this.mode === Tag.CLASSIFICATION && loadService.setClassificationObj(data);
                await this.getImagesFromServer(data);

        }
    }

    /**
     * setRectsColorCopy - set color rects ui
     */
    setRectsColorCopy = () => {
        this.rectColorCopy.splice(0, this.rectColorCopy.length);
        canvasService.rectList.forEach((rect) => {
            const newRect = JSON.parse(JSON.stringify(rect));
            const syntheticRect = {coordinates: [{x: newRect.pointLeftTop.x, y: newRect.pointLeftTop.y, z: 0}, {x: newRect.pointRightBottom.x, y: newRect.pointRightBottom.y, z: 0}], color: newRect.color.match(/\d+/g).map(Number)};

            this.rectColorCopy.push(syntheticRect);
        });
    }

    /**
     * changeCropColorMode - change crop color mode in Synthetic mode
     * @param isInCropMode - boolean true/false
     */
    @action changeCropColorMode = (isInCropMode) => {
        this.isInCropMode = isInCropMode;
        canvasService.isInCropMode = this.isInCropMode;
        this.stopEditShape();
        if (isInCropMode) {
            this.setRectsColorCopy();
        } else {
            canvasService.setColorSynthetic(this.rectColorCopy);
        }
        canvasService.drawAll();
    }

    /**
     * addCanvas - add to canvas after received image from websocket
     * @param canvasRef - canvas ref
     * @param width - canvas width
     * @param height - canvas height
     * @param img - base64
     * @param index - image index
     */
    @action addCanvas = (canvasRef: HTMLCanvasElement | null, width: string, height: string, img: IImage | null, index) => {
        const lastType = this.chosenType;

        this.showPointsList = false;
        this.cleanList();
        canvasService.addCanvas(canvasRef, width, height, toJS(img)).then(() => {

            const allProperties = toJS(this.allProperties);

            if (allProperties.length > 0) {
                this.className = '';
                this.className = loadService.allDataFromLocal![index]!.imageObject.className || this.classes && this.classes[0] || '';
                this.setLabelList();
                this.setAttributeList();
                allProperties[index].forEach((obj) => {
                    if ('label' in obj) {
                        this.setChosenLabel(obj.label);
                        !obj.id && this.labelList.findIndex(((label) => label === obj.label)) === -1 && this.addToDefaultLabels([obj.label]);
                    } else {
                        this.labelList.length > 0 && this.setChosenLabel(this.labelList[0]);
                    }
                    this.setColor(obj.label);
                    const attributes = typeof obj.attributes === 'string' ? obj.attributes : obj.attributes[0];

                    if (attributes) {
                        this.setChosenAttribute(attributes);
                        !obj.id && this.attributeList.findIndex(((attribute) => attribute === attributes)) === -1 && this.addToDefaultAttributes([attributes]);
                    } else {
                        this.attributeList.length > 0 && this.setChosenAttribute(this.attributeList[0]);
                    }
                    if (!obj.color) {
                        // eslint-disable-next-line no-param-reassign
                        obj = JSON.parse(JSON.stringify(loadService.setCoordinatesToCorrectSize(obj, this.ratio, false)));
                    }
                    if (obj.type.toLowerCase() === 'point') {
                        canvasService.drawCircle(obj.coordinates.x, obj.coordinates.y, this.chosenColor, true, obj.label, this.chosenAttribute);
                        this.updateType('Point');
                        if (obj.id) {
                            this.allShapes.push(obj);
                        } else {
                            this.addToList({x: obj.coordinates.x, y: obj.coordinates.y}, canvasService.pointList.length - 1);
                        }
                    } else if (obj.type.toLowerCase() === 'box') {
                        this.updateType('Box');
                        canvasService.drawRectangle(obj.coordinates[0].x, obj.coordinates[0].y, obj.coordinates[1].x - obj.coordinates[0].x, obj.coordinates[1].y - obj.coordinates[0].y, this.chosenColor, true, obj.label, this.chosenAttribute);
                        const rectIndex = canvasService.rectList.length - 1;

                        if (obj.id) {
                            this.allShapes.push(obj);
                        } else {
                            this.addToList(canvasService.getRectCoordinates(rectIndex), rectIndex);
                        }
                    } else if (obj.type.toLowerCase() === 'segment') {
                        this.updateType('segment');
                        const coordinatesArray = obj.coordinates[0].length > 0 ? obj.coordinates[0] : obj.coordinates;

                        coordinatesArray.forEach((s, index) => {
                            s.color = this.chosenColor;
                            s.isInEdit = false;
                            if (index === 0) {
                                s.label = obj.label;
                                s.attribute = this.chosenAttribute;
                            }
                        });
                        canvasService.segmentList.push(coordinatesArray);
                        const segmentIndex = canvasService.segmentList.length - 1;

                        canvasService.drawPolygon(coordinatesArray, segmentIndex);


                        if (obj.id) {
                            this.allShapes.push(obj);
                        } else {
                            this.addToList(obj.coordinates, segmentIndex);
                        }
                    }
                });
            }

            this.chosenType = this.mode !== Tag.SEGMENTHOR ? lastType : 'Box';
            this.stopEditShape();
            this.setLabelList();
            this.setAttributeList();
            this.attributeList.length > 0 && this.setChosenAttribute(this.attributeList[0]);
            this.labelList.length > 0 && this.setChosenLabel(this.labelList[0]);
            this.showPointsList = true;
        });
    }

    /**
     * updateAttribute - update attribute array
     */
    @action updateAttribute = (value, index) => {
        this.allShapes[index].attributes = value;
        const [shapeType, shapeIndex] = this.allShapes[index].id.split('_');

        canvasService.changeShapeProperties(value, shapeType, shapeIndex, 'attribute');
    }

    /**
     * updateChosenLabel - update label list
     */
    @action updateChosenLabel = (value, index) => {
        this.allShapes[index].label = value;
        this.allShapes[index].color = COLORS[value] ? COLORS[value] : 'rgb(0, 0, 0)';
        const [shapeType, shapeIndex] = this.allShapes[index].id.split('_');

        canvasService.changeColor(this.allShapes[index].color, shapeType, shapeIndex);
        canvasService.changeShapeProperties(value, shapeType, shapeIndex, 'label');
    }

    /**
     * setChosenAttribute - set chosen attribute
     */
    @action setChosenAttribute=(value) => {
        this.chosenAttribute = value;
    }

    /**
     * setChosenLabel - set chosen label
     */
    @action setChosenLabel=(value) => {
        this.chosenLabel = value;
    }

    /**
     * updateType - update shape type
     * @param type
     */
    @action updateType = (type) => {
        this.chosenType = type;
    };

    /**
     * setRatio - set ratio
     */
    @action setRatio = (ratio) => this.ratio = ratio;

    /**
     * setColor - set shape color
     */
    @action setColor = (label) => {
        this.chosenColor = COLORS[label] ? COLORS[label] : 'rgb(0, 0, 0)';
    }

    /**
     * setImageIndex - when user move from images
     * @param index - image index
     * @param isFromTask - the special case when listening mode
     */
    @action setImageIndex = (index, isFromTask = false) => {
        if ((this.imageIndex === index || index > this.allImages.length - 1) && !isFromTask) {

            return;
        }
        const allShapesObject = toJS(this.allShapes);

        isFromTask && loadService.setAllDataFromLocalJson(this.imageIndex, allShapesObject, this.ratio, this.className);
        this.allProperties[this.imageIndex] = allShapesObject;
        this.imageIndex = index;
        !isFromTask && this.setImageOnCanvas(index);
    };

    /**
     * setContainerRef - canvas container
     */
    @action setContainerRef = (containerRef, canvasRef) => {
        this.containerRef = containerRef;
        this.canvasRef = canvasRef;
    }

    /**
     * setImageOnCanvas -set image on canvas on first time
     */
    @action setImageOnCanvas = (index) => {
        const widthContainer = this.containerRef && this.containerRef.current && (this.containerRef.current.clientWidth);
        const heightContainer = this.containerRef && this.containerRef.current && (this.containerRef.current.clientHeight);
        const img = loadService!.allDataFromLocal![index] ? loadService!.allDataFromLocal![index]!.img : null;

        const setSize = () => {
            const imageDimension = loadService.aspectRatio(widthContainer, heightContainer, img);

            this.setRatio(imageDimension!.ratio);
            const isIndexInPosition = this.mode === Tag.CLASSIFICATION ? true : index === this.imageIndex;

            img && isIndexInPosition && this!.canvasRef && this.addCanvas(this!.canvasRef!.current, imageDimension!.width, imageDimension!.height, img, index);
        };

        if (img) {
            if (img.width === 0 && img.height === 0) {
                const image = new Image();

                image.src = img.src;
                image.onload = () => {
                    img.width = image.width;
                    img.height = image.height;
                    setSize();
                };
            } else {
                setSize();
            }
        } else {
            canvasService.clearCanvas(true);
            this.cleanList();
        }
    }

    /**
     * addToDefaultAttributes - add to default attributes
     */
    @action addToDefaultAttributes = (addedList) => addedList && addedList.forEach((att) => (!DEFAULT_ATTRIBUTES[att] && att.length > 0) && (DEFAULT_ATTRIBUTES[att] = att));

    /**
     * addToDefaultLabels - add to default labels
     */
    @action addToDefaultLabels = (addedList) => addedList && addedList.forEach((label) => (!DEFAULT_LABELS[label] && label.length > 0) && (DEFAULT_LABELS[label] = label));

    /**
     * reOrganizedArray - after deleting the shape in the array need to change the ids
     * @param type
     * @param index
     */
    reOrganizedArray = (type, index) => {
        this.allShapes.forEach((shape) => {
            const [shapeType, shapeIndex] = shape.id.split('_');
            const IndexNum = +shapeIndex;

            if (type === shapeType && index < shapeIndex) {
                shape.id = `${shapeType}_${IndexNum - 1}`;
            }
        });
    }

    /**
     * deleteShape - delete shape from allShapes
     */
    @action deleteShape = (index) => {
        const [type, canvasIndex] = this.allShapes[index].id.split('_');
        const canvasIndexNum = +canvasIndex;

        if (type.toLowerCase() === 'point') {
            this.stopEditShape();
            canvasService.deletePoint(canvasIndexNum);
        } else if (type.toLowerCase() === 'box') {
            this.stopEditShape();
            canvasService.deleteRect(canvasIndexNum);
        } else if (type.toLowerCase() === 'segment') {
            canvasService.deleteSegment(canvasIndexNum);
            this.stopEditShape();
        }
        this.allShapes.splice(index, 1);
        this.reOrganizedArray(type, canvasIndex);
        this.sendTask('update_annotation_data', '', '', true);
    }

    /**
     * findShapeById - find shape by id
     */
    findShapeById = (id):[shape?:IShape, shapeIndex?:number] => {
        let shapeIndex = -1;
        const shape = this.allShapes.find((shape, index) => {
            shapeIndex = index;

            return shape.id === id;
        });


        return [shape, shapeIndex];
    }

    /**
     * handleMouseDownSegment - check if user press on segment (polygon)
     * @param e - touch event
     * @param mouseX - user x
     * @param mouseY - user y
     * @param mouseDown - mouse down callback
     */
    @action handleMouseDownSegment = (e, mouseX, mouseY, mouseDown) => {
        let isNewPressed = false;

        if (this.indexSegmentEditMode === -1 && this.chosenType.toLowerCase() === 'segment') {
            this.setColor(this.chosenLabel);
            isNewPressed = mouseDown(e, {pointIndex: -1 }, {rectIndex: -1}, {isNew: true, color: this.chosenColor, segmentIndex: this.indexSegmentEditMode, label: this.chosenLabel, attribute: this.chosenAttribute}, this.chosenType);

            if (isNewPressed) {
                this.cursor = 'pointer';
                this.addToList(canvasService.segmentList[canvasService.segmentList.length - 1], canvasService.segmentList.length - 1);
                this.indexSegmentEditMode = canvasService.segmentList.length - 1;
                this.SetPanMode(false);
            } else {
                const index = this.allShapes.findIndex((shape) => shape.id === `${this.chosenType.toLowerCase()}_${canvasService.indexSegment}`);

                index > -1 && this.editFromTicket(index);
            }
        } else if (this.indexSegmentEditMode > -1) {
            mouseDown(e, {pointIndex: -1 }, {rectIndex: -1}, {segmentIndex: this.indexSegmentEditMode}, this.chosenType);
            const [shape] = this.findShapeById(`${this.chosenType.toLowerCase()}_${this.indexSegmentEditMode}`);

            shape!.isInEditMode = true;

            canvasService.segmentEdit(mouseX, mouseY, canvasService.segmentList[canvasService.indexSegment][0].color, canvasService.segmentList[canvasService.indexSegment]);
            shape!.coordinates = canvasService.segmentList[canvasService.indexSegment];

            if (canvasService.indexSegment < 0) {
                this.mode === Tag.DEFAULT && this.sendTask('update_annotation_data', '', '', true);
                setTimeout(() => {
                    this.stopEditShape();
                }, 100);
            } else {
                shape!.isInEditMode = true;
            }
        }
    }

    /**
     * handleMouseDownPoint - check if user press on point
     * @param e - touch event
     * @param mouseX - user x
     * @param mouseY - user y
     * @param mouseDown - mouse down callback
     */
    @action handleMouseDownPoint = (e, mouseX, mouseY, mouseDown) => {
        let canCheckRect = true;
        let isNewPressed = false;

        if (this.indexPointInEditMode === -1 && this.indexRectInEditMode === -1 && this.chosenType.toLowerCase() === 'point') {
            canCheckRect = false;
            this.setColor(this.chosenLabel);
            // eslint-disable-next-line no-param-reassign
            isNewPressed = mouseDown(e, {isNew: true, color: this.chosenColor, pointIndex: this.indexPointInEditMode, label: this.chosenLabel, attribute: this.chosenAttribute }, {rectIndex: -1}, {segmentIndex: -1}, this.chosenType);

            if (isNewPressed) {
                this.cursor = 'pointer';
                this.addToList({x: mouseX, y: mouseY}, canvasService.pointList.length - 1);
                this.indexPointInEditMode = canvasService.pointList.length - 1;
                this.SetPanMode(false);
            } else {
                const index = this.allShapes.findIndex((shape) => shape.id === `${this.chosenType.toLowerCase()}_${canvasService.indexPointPress}`);

                index > -1 && this.editFromTicket(index);
            }
        } else if (this.indexPointInEditMode > -1) {
            canCheckRect = false;
            mouseDown(e, {pointIndex: this.indexPointInEditMode }, {rectIndex: -1}, {segmentIndex: -1}, this.chosenType);
            const [shape] = this.findShapeById(`point_${this.indexPointInEditMode}`);

            if (canvasService.indexPointPress < 0) {
                this.mode === Tag.DEFAULT && this.sendTask('update_annotation_data', '', '', true);
                setTimeout(() => {
                    this.stopEditShape();
                }, 100);
            } else {
                shape!.isInEditMode = true;
            }
        }

        return [isNewPressed, canCheckRect];
    }

    /**
     * handleMouseDownRect - check if user press on rect
     * @param e - touch event
     * @param mouseX - user x
     * @param mouseY - user y
     * @param mouseDown - mouse down callback
     * @param isNewPressed - is new shape
     */
    @action handleMouseDownRect = (e, mouseX, mouseY, mouseDown, isNewPressed) => {
        let canCheckSegment = false;

        if (this.indexPointInEditMode === -1 && this.indexRectInEditMode === -1 && this.chosenType.toLowerCase() === 'box') {
            this.setColor(this.chosenLabel);
            // eslint-disable-next-line no-param-reassign
            isNewPressed = mouseDown(e, {pointIndex: -1}, {isNew: true, color: this.chosenColor, rectIndex: this.indexRectInEditMode, label: this.chosenLabel, attribute: this.chosenAttribute }, {segmentIndex: -1}, this.chosenType);
            if (isNewPressed) {
                const rectIndex = canvasService.rectList.length - 1;

                this.cursor = 'pointer';
                this.addToList(canvasService.getRectCoordinates(rectIndex), rectIndex);
                this.indexRectInEditMode = rectIndex;
                this.SetPanMode(false);
            } else {
                const index = this.allShapes.findIndex((shape) => shape.id === `${this.chosenType.toLowerCase()}_${canvasService.indexRect}`);

                index > -1 && this.editFromTicket(index);
            }
        } else if (this.indexRectInEditMode > -1) {
            mouseDown(e, {pointIndex: -1}, {rectIndex: this.indexRectInEditMode}, {segmentIndex: -1}, this.chosenType);
            const [shape] = this.findShapeById(`box_${this.indexRectInEditMode}`);

            if (canvasService.indexRect < 0) {
                this.mode === Tag.DEFAULT && this.sendTask('update_annotation_data', '', '', true);
                setTimeout(() => {
                    this.stopEditShape();
                }, 100);
            } else {
                shape!.isInEditMode = true;
            }
        } else {
            canCheckSegment = true;
        }

        return canCheckSegment;
    }

    /**
     * handleMouseDown - when user press on image
     * @param e - touch event
     */
    // eslint-disable-next-line complexity
    @action handleMouseDown=(e) => {
        if (!this.isInPanMode) {
            e.stopPropagation();
            e.preventDefault();
        }
        const {touchMoveCalculate, mouseDown} = canvasService;
        const {mouseX, mouseY} = touchMoveCalculate(e);

        if (!this.isInSyntheticMode) {
            canvasService.isInSyntheticMode = false;
            if (e.button === 0 && !this.isInPanMode && this!.allImages[this.imageIndex] && !this!.allImages![this.imageIndex]!.isVideoLoad && this.mode !== Tag.CLASSIFICATION && this.mode !== Tag.DEBUG && canvasService.canvas) {
                this.setHitlTimeOut(hitl.IME_DELAY_BASIC, false);
                this.setColor(this.chosenLabel);
                const [isNewPressed, canCheckRect] = this.handleMouseDownPoint(e, mouseX, mouseY, mouseDown);
                const canCheckSegment = canCheckRect ? this.handleMouseDownRect(e, mouseX, mouseY, mouseDown, isNewPressed) : false;

                canCheckSegment && this.handleMouseDownSegment(e, mouseX, mouseY, mouseDown);
            } else if (this!.allImages![this.imageIndex]!.isVideoLoad || this.mode !== Tag.CLASSIFICATION) {
                this.cursor = !this.isInPanMode ? 'default-pointer' : this.cursor;
            }
        } else if (this.isInCropMode) {
            // Crop mode
            if (this.addCropPic > -1) {
                canvasService.addCropsPictures(this.addCropPic, mouseX, mouseY);
                this.addCropPic = -1;
            } else {
                this.setColor(this.chosenLabel);
                canvasService.isInSyntheticMode = true;
                mouseDown(e, {pointIndex: -1}, {isNew: true, color: this.chosenColor, rectIndex: this.indexRectInEditMode, label: this.chosenLabel, attribute: this.chosenAttribute }, {segmentIndex: -1}, this.chosenType);
                const rectIndex = canvasService.rectList.length - 1;

                canvasService.isInCopCutMode = (canvasService.rectList.length > canvasService.cropsPictures.length) || (canvasService.rectList.length === 0 && canvasService.cropsPictures.length === 0);
                this.indexRectInEditMode = rectIndex;
                this.indexCrop = canvasService.indexCrop;
                this.SetPanMode(false);
                this.cursor = this.indexCrop > -1 ? 'pointer' : 'crosshair';
            }


        } else if (this.isInArsenalMode) {
            // color mode in Arsenal Mode
            const colors:string = canvasService.pickColor(mouseX, mouseY);

            this.colorPicker.push({
                colors,
                isAllow: false,
                name: `${this.projectName}_${parseInt(`${new Date().getTime() / 1000}`, 10)}`
            });
            this.addToPatches('color');

            this.SetPanMode(false);
            this.cursor = this.indexCrop > -1 ? 'pointer' : 'crosshair';
        } else if (this.isInSyntheticMode && !this.isInArsenalMode && !this.isInCropMode) {
            // color mode in create color mode
            const colorRgb = this.addColorPic > -1 ? `rgb(${this.colorPicker[this.addColorPic].colors})` : '';
            const isNewPressed = mouseDown(e, {pointIndex: -1}, {isNew: true, color: colorRgb, rectIndex: this.indexRectInEditMode, label: this.chosenLabel, attribute: this.chosenAttribute }, {segmentIndex: -1}, this.chosenType);

            if (this.addColorPic > -1 && isNewPressed) {
                this.setColor(colorRgb);
                canvasService.isInSyntheticMode = true;
                this.syntheticColorEdit.push({
                    'is_inverted': true,
                    'is_manual_threshold': false,
                    'dilate_scroll': 1,
                    'threshold_scroll': 0,
                    'blur_scroll': 1,
                });
            }

            this.addColorPic = -1;
            this.indexRectInEditMode = canvasService.indexRect;
            this.indexColor = canvasService.indexRect;
            canvasService.indexRect === -1 && canvasService.drawAll();
            this.SetPanMode(false);
            this.cursor = this.indexCrop > -1 ? 'pointer' : 'crosshair';
        }
    }

    /**
     * handleMove - when user move on canvas
     * @param e - touch event
     */
    // eslint-disable-next-line complexity
    @action handleMove=(e) => {
        if (this!.allImages![this.imageIndex] && (this.mode !== Tag.CLASSIFICATION && this.mode !== Tag.DEBUG && canvasService.canvas && !this!.allImages![this.imageIndex]!.isVideoLoad)) {
            const {touchMoveCalculate, mouseMove} = canvasService;
            const {mouseX, mouseY} = touchMoveCalculate(e);

            mouseMove(e, this.indexPointInEditMode, this.indexRectInEditMode);

            if (this.indexPointInEditMode > -1 && canvasService.indexPointPress > -1) {
                const [shape] = this.findShapeById(`${this.chosenType.toLowerCase()}_${this.indexPointInEditMode}`);

                if (shape) {
                    shape!.position = [mouseX, mouseY].join(',');
                    shape!.coordinates = {x: mouseX, y: mouseY};
                }
            } else if (this.indexRectInEditMode > -1 && canvasService.indexRect > -1) {
                const [shape] = this.findShapeById(`${this.chosenType.toLowerCase()}_${this.indexRectInEditMode}`);

                if (shape) {
                    shape!.coordinates.splice(0, shape!.coordinates.length);
                    canvasService.getRectCoordinates(this.indexRectInEditMode).forEach((cord) => {
                         shape!.coordinates.push(cord);
                    });
                    shape!.position = shape!.coordinates.map((arr) => Object.values(arr)).join(',');
                }
            } else if (this.indexSegmentEditMode > -1 && canvasService.indexSegment > -1) {
                const [shape] = this.findShapeById(`${this.chosenType.toLowerCase()}_${this.indexSegmentEditMode}`);

                shape && (shape!.coordinates = canvasService.segmentList[canvasService.indexSegment]);
            }
        } else if ((this!.allImages![this.imageIndex] && this!.allImages![this.imageIndex]!.isVideoLoad || this.mode === Tag.DEBUG) || !(this!.allImages![this.imageIndex])) {
            this.cursor = 'default-pointer';
        }
        this.indexCrop = canvasService.indexCrop;
        if (this.mode === Tag.CLASSIFICATION) {
            this.cursor = this.isInPanMode ? 'grabbing' : 'default-pointer';
        } else {
            this.cursor = this.indexCrop > -1 ? 'pointer' : this.cursor;
        }
    }

    /**
     * stopEditShape - stop edit shape
     */
    @action stopEditShape=() => {
        const {stopEdit} = canvasService;

        if (this.lastType.length > 0) {
            this.chosenType = this.lastType;
            this.lastType = '';
        }
        this.indexPointInEditMode = -1;
        this.indexRectInEditMode = -1;
        this.indexSegmentEditMode = -1;
        this.indexCrop = -1;
        this.addColorPic = -1;
        this.indexColor = -1;
        const copyShapes:IShape[] = this.allShapes.map((shape) => {
            shape.isInEditMode = false;

            return shape;
        });

        this.allShapes.splice(0, this.allShapes.length);
        this.allShapes = copyShapes;
        this.SetPanMode(false);
        canvasService.canvas && stopEdit();
        this.setHitlTimeOut(hitl.IME_DELAY_BASIC, false);
    }

    /**
     * editFromTicket - when user press on ticket edit
     */
    @action editFromTicket=(index) => {
        this.stopEditShape();
        this.allShapes[index].isInEditMode = true;
        const [type, canvasIndex] = this.allShapes[index].id.split('_');

        this.cursor = 'pointer';

        this.lastType = this.chosenType;
        this.chosenType = type;
        const canvasIndexNum = +canvasIndex;

        if (type.toLowerCase() === 'point') {
            this.indexPointInEditMode = canvasIndexNum;
        }
        if (type.toLowerCase() === 'box') {
            this.indexRectInEditMode = canvasIndexNum;
        } else if (type.toLowerCase() === 'segment') {
            this.indexSegmentEditMode = canvasIndexNum;
            canvasService.indexSegment = canvasIndexNum;
        }
        this.SetPanMode(false);
        canvasService.canvas && canvasService.drawAll(-100, -100, this.indexPointInEditMode, this.indexRectInEditMode);

        return this.indexPointInEditMode;
    }

    /**
     * onZoomChange  - when user zoom in and out
     */
    @action onZoomChange = (scale) => {
        canvasService.onZoomChange(scale);
        canvasService.canvas && canvasService.drawAll(-100, -100, this.indexPointInEditMode, this.indexRectInEditMode);
    }

    /**
     * findIfLoadMore - find if can load more images
     */
    @action findIfLoadMore = () => this.allImages.length < loadService.allDataFromLocal.length;

    /**
     * onScrollEnd - when user come to end of scrolling
     */
     @action onScrollEnd = () => {
         if (this.findIfLoadMore()) {
             loadService.requestMore(this.allImages.length - 1, gallery.MAX_IMAGE_SIZE).forEach((data) => {
                 this.mode === Tag.DEFAULT && (data.img.finished = !!data.imageObject.finished);
                 const filename = `${data.filename}.${data.fileType}`;
                 const copyObj = data.img;

                 copyObj.filename = filename;

                 const copyImages:IImage[] = [...this.allImages, copyObj];

                 this.allImages.splice(0, this.allImages.length);
                 this.allImages = copyImages;

                 this.allProperties.push(JSON.parse(JSON.stringify(data.imageObject.annotations)));
             });
         }
     }

    /**
     * onPressOnImageGallery - when user press on image (the small image)
     * @param index - image index
     */
    @action onPressOnImageGallery = (index) => {
        this.stopEditShape();
        const allShapesObject = toJS(this.allShapes);

        loadService.setAllDataFromLocalJson(this.imageIndex, allShapesObject, this.ratio, this.className);
        this.setImageIndex(index);
        const element = document.getElementById(`img_${this.imageIndex}`);

         element!.scrollIntoView({behavior: 'smooth', block: 'center'});
         index === this.allImages.length - 1 && this.onScrollEnd();
         if (this.mode === Tag.SEGMENTHOR) {
             canvasService.cropsPictures.splice(0, canvasService.cropsPictures.length);
             this.isInSyntheticMode = false;
             canvasService.isInSyntheticMode = false;
         }
    }

     /**
     * moveDownOrUp - when user mover right or left in images
     * @param dir - the direction (1/-1)
     * @param funcDate - let user move between image every 400 milliseconds
     */
     moveDownOrUp = (dir:number, funcDate = new Date().getTime()) => {
         let isReturn = false;

         this.lastDateTime > 0 && funcDate - this.lastDateTime < gallery.DELAY_TIME && (isReturn = true);
         const isCanMove = dir > 0 ? this.imageIndex < loadService.allDataFromLocal.length - 1 : this.imageIndex - 1 >= 0;

         if (isCanMove && this.imageIndex + dir <= this.allImages.length - 1 && !isReturn) {
             this.stopEditShape();
             this.lastDateTime = funcDate;

             this.setImageIndex(this.imageIndex + dir, false);
             const element = document.getElementById(`img_${this.imageIndex}`);

             element!.scrollIntoView({behavior: 'smooth', block: 'center'});
         }
     }

     /**
     * SetPanMode - Set Pan (move image on zoom in) mode
     * @param isInPanMode - boolean
     */
     @action SetPanMode = (isInPanMode) => {
         this.isInPanMode = this.indexPointInEditMode > -1 || this.indexRectInEditMode > -1 ? false : isInPanMode;
         let pointer: string;

         if (this.mode === Tag.CLASSIFICATION) {
             pointer = 'default-pointer';
         } else {
             pointer = this.indexPointInEditMode > -1 || this.indexRectInEditMode > -1 ? 'pointer' : 'crosshair';
         }


         if (this!.allImages![this.imageIndex] && this!.allImages![this.imageIndex]!.isVideoLoad) {
             this.cursor = 'default-pointer';
         } else {
             this.cursor = this.isInPanMode && !(this.indexPointInEditMode > -1 || this.indexRectInEditMode > -1) ? 'grabbing' : pointer;
         }
     }

    /**
     * setSiaDefault - set to default
     */
    setSiaDefault = () => {
        this.cleanList();
        this.progressImageTagging = 0;
        this.labelList.splice(0, this.labelList.length);
        this.attributeList.splice(0, this.attributeList.length);
        this.allImages.splice(0, this.allImages.length);
        this.allProperties.splice(0, this.allProperties.length);
        this.imageIndex = -1;
        this.totalVideos = 0;
        this.isTrainError = false;
        this.accuracyFinish = false;
        this.videoIndex = 0;
        this.chosenLabel = '';
        this.totalImages = 0;
        this.mode = 'taggingMode';
        this.serverWsTaskName = '';
        this.fileName = '';
        this.isInPanMode = false;
        this.chosenAttribute = '';
        this.cursor = 'crosshair';
        this.lastType = '';
        this.chosenType = 'Point';
        this.chosenColor = 'rgb(255, 100, 6)';
        this.indexPointInEditMode = -1;
        this.indexRectInEditMode = -1;
        this.indexSegmentEditMode = -1;
        this.imageIndexInUpdate = -1;
        this.projectName = '';
        this.lastDateTime = 0;
        this.ratio = 0;
        DEFAULT_LABELS = {};
        COLORS = {};
        DEFAULT_ATTRIBUTES = {};

    }

    /**
     * findButtonMode - find Button Mode
     */
    @action findButtonMode = () => this.allImages[this.imageIndex]!.buttonMode
}
export default new SiaStore();
